import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { UpV1Service } from './UpV1Service.Generated';

@Injectable({
  providedIn: 'root'
})
export class FeatureManagementService implements OnDestroy {

  private _destroySubscription: Subject<void> = new Subject();

  readonly calculationExportFeatureFlag = 'materials-calculation-export';
  readonly uploadCSVFileFeatureFlag = 'upload-csv-file';
  readonly showOrganizationCodeFeatureFlag = 'US21013-show-organisationcode';
  readonly showOrganizationAccessFeatureFlag = 'US21256-ShowOrganizationAccessModal';
  readonly showDataPortalApiButtonFeatureFlag = 'US21009-show-data-api-button';

  constructor(private _userPortalService: UpV1Service) { }

  ngOnDestroy(): void {
    this._destroySubscription.next();
    this._destroySubscription.complete();
  }

  /**
  * Checks if the calculation export feature is enabled.
  * @return {Observable<boolean>} - An observable that emits a boolean value indicating whether the calculation export feature is enabled.
  */
  isCalculationExportEnabled(): Observable<boolean> {
    return this._userPortalService.isFeatureEnabledForUser(this.calculationExportFeatureFlag).pipe(takeUntil(this._destroySubscription));
  }

  /**
* Checks if the Upload CSV file feature is enabled.
* @return {Observable<boolean>} - An observable that emits a boolean value indicating whether to show upload CSV UI.
*/
  isUploadCSVFileEnabled(): Observable<boolean> {
    return this._userPortalService.isFeatureEnabledForUser(this.uploadCSVFileFeatureFlag).pipe(takeUntil(this._destroySubscription));
  }

  /**
* Checks if the ShowOrganizationCode feature is enabled.
* @return {Observable<boolean>} - An observable that emits a boolean value indicating whether to show OrganizationCode.
*/
  isShowOrganizationCode(): Observable<boolean> {
    return this._userPortalService.isFeatureEnabledForUser(this.showOrganizationCodeFeatureFlag).pipe(takeUntil(this._destroySubscription));
  }


  /**
* Checks if the ShowOrganizationAccessModal feature is enabled.
* @return {Observable<boolean>} - An observable that emits a boolean value indicating whether to show OrganizationAccess Modal.
*/
  showOrganizationAccessModal(): Observable<boolean> {
    return this._userPortalService.isFeatureEnabledForUser(this.showOrganizationAccessFeatureFlag).pipe(takeUntil(this._destroySubscription));
  }

  /**
* Checks if the Data API button feature is enabled.
* @return {Observable<boolean>} - An observable that emits a boolean value indicating whether to show the Data API button.
*/
  showDataPortalApiButton(): Observable<boolean> {
    return this._userPortalService.isFeatureEnabledForUser(this.showDataPortalApiButtonFeatureFlag).pipe(takeUntil(this._destroySubscription));
  }

}
